<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{tender.label}}</h4>
    </div>
    <div class="cell shrink">
    </div>
  </div>
</div>

<div class="card-body vertical-center">
  <div *ngIf="proposalsForChart && proposalsForChart.length > 0; else noProposals"
       class="d-block padding-h">
    <div class="d-block margin-b-xs">
      <span [ngStyle]="{'visibility': isFirstDurationSelected() ? 'hidden' : 'visible'}"
            class="cursor-hover fas fa-arrow-alt-circle-left c-medium-gray"
            (click)="previousDuration()"></span>
      <span class="c-dark-gray" style="font-weight:500;">
        {{'widget.funding-tender.duration' | translate:{years: durationChoosen.year, months: durationChoosen.month} }}
      </span>
      <span (click)="nextDuration()"
            [ngStyle]="{'visibility': isLastDurationSelected() ? 'hidden' : 'visible'}"
            class="cursor-hover fas fa-arrow-alt-circle-right c-medium-gray"></span>
    </div>
    <div [chart]="chart" class="d-block" id="widget-mao-chart" style="height: 96px;width:99%;"></div>
  </div>

  <ng-template #noProposals>
    <div class="icone-placeholder">
      <span class="opt opt-stat"></span>
    </div>
    <div class="padding-v-xl margin-v" style="text-align:center;">
      <span class="label-mao-small c-dark-gray">{{'widget.funding-tender.no-proposals-to-analyzed' | translate}}</span>
    </div>
  </ng-template>
</div>

<div class="card-footer">
  <a (click)="actionEvent.emit('widget.funding-tender.analyse-offers');" [href]="goToFundingTenderReceiptPage()"
     class="button insito">
      <span
        [title]="'widget.funding-tender.analyse-offers' | translate">{{'widget.funding-tender.analyse-offers' | translate}}</span>
  </a>
</div>


